import {USER_ROLES} from "@/constants";

export default class StaffMemberPolicy
{
    /**
     * Determine whether the user can view any models.
     *
     * @param  {object}  user
     * @return mixed
     */
    viewAny(user)
    {
        return [USER_ROLES.ADMIN, USER_ROLES.USER, USER_ROLES.CONSTRUCTION_MANAGER].includes(user.role);
    }

    /**
     * Determine whether the user can view the model.
     *
     * @param  {object}  user
     * @param  {object}  staffmember
     * @return {mixed}
     */
    view(user, staffmember)
    {
        //
    }

    /**
     * Determine whether the user can create models.
     *
     * @param  {object}  user
     * @return {mixed}
     */
    create(user)
    {
        //
    }

    /**
     * Determine whether the user can update the model.
     *
     * @param  {object}  user
     * @param  {object}  staffmember
     * @return {mixed}
     */
    update(user, staffmember)
    {
        //
    }

    /**
     * Determine whether the user can restore the model.
     *
     * @param  {object}  user
     * @param  {object}  staffmember
     * @return {mixed}
     */
    restore(user, staffmember)
    {
        //
    }

    /**
     * Determine whether the user can delete the model.
     *
     * @param  {object}  user
     * @param  {object}  staffmember
     * @return {mixed}
     */
    delete(user, staffmember)
    {
        //
    }

    /**
     * Determine whether the user can permanently delete the model.
     *
     * @param  {object}  user
     * @param  {object}  staffmember
     * @return {mixed}
     */
    forceDelete(user, staffmember)
    {
        //
    }
}
